/* Video testimonials carousel — click to play inline, mute toggle, pause others */
(function () {
  'use strict';

  const SOUND_ON_SVG =
    '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';

  const SOUND_OFF_SVG =
    '<svg viewBox="0 0 24 24"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>';

  let currentlyPlaying = null;

  function pauseItem(item) {
    if (!item) return;
    const inline = item.querySelector('.inline-video-container');
    if (inline) {
      const v = inline.querySelector('video');
      if (v) {
        v.pause();
      }
      inline.remove();
    }
    item.classList.remove('video-playing');
    item.classList.add('video-paused');
  }

  function playItem(item, container) {
    if (currentlyPlaying && currentlyPlaying !== item) {
      pauseItem(currentlyPlaying);
    }

    // If already playing, toggle pause
    if (item.classList.contains('video-playing')) {
      pauseItem(item);
      currentlyPlaying = null;
      return;
    }

    const hiddenData = item.querySelector('.hidden-video-data');
    if (!hiddenData) return;

    const sourceVideo = hiddenData.querySelector('video');
    if (!sourceVideo) return;

    const clone = sourceVideo.cloneNode(true);
    clone.autoplay = true;
    clone.muted = false;
    clone.loop = true;
    clone.playsInline = true;
    clone.removeAttribute('muted');
    clone.setAttribute('playsinline', 'playsinline');

    const inline = document.createElement('div');
    inline.className = 'inline-video-container';
    inline.appendChild(clone);

    let soundBtn = null;
    if (container.dataset.showSoundControls === 'true') {
      soundBtn = document.createElement('button');
      soundBtn.className = 'video-sound-button';
      soundBtn.setAttribute('aria-label', 'Mute video');
      soundBtn.dataset.muted = 'false';
      soundBtn.innerHTML = SOUND_ON_SVG;
      soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        const isMuted = soundBtn.dataset.muted === 'true';
        if (isMuted) {
          clone.muted = false;
          soundBtn.dataset.muted = 'false';
          soundBtn.setAttribute('aria-label', 'Mute video');
          soundBtn.innerHTML = SOUND_ON_SVG;
        } else {
          clone.muted = true;
          soundBtn.dataset.muted = 'true';
          soundBtn.setAttribute('aria-label', 'Unmute video');
          soundBtn.innerHTML = SOUND_OFF_SVG;
        }
      });
      inline.appendChild(soundBtn);
    }

    item.querySelector('.video-thumbnail').appendChild(inline);
    item.classList.remove('video-paused');
    item.classList.add('video-playing');

    clone.addEventListener('playing', function () {
      inline.classList.add('is-ready');
    }, { once: true });

    const playPromise = clone.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      // Browser blocked autoplay with sound — fall back to muted
      playPromise.catch(function () {
        clone.muted = true;
        if (soundBtn) {
          soundBtn.dataset.muted = 'true';
          soundBtn.setAttribute('aria-label', 'Unmute video');
          soundBtn.innerHTML = SOUND_OFF_SVG;
        }
        clone.play().catch(function () {});
      });
    }

    currentlyPlaying = item;
  }

  function initCarousel(container) {
    if (container.dataset.videoCarouselInit === '1') return;
    container.dataset.videoCarouselInit = '1';

    const items = container.querySelectorAll('.video-item');
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        playItem(item, container);
      });
    });

    // Autoplay first video if enabled
    if (container.dataset.enableAutoplay === 'true' && items.length > 0) {
      // Delay slightly so lazy-loaded assets are ready
      setTimeout(function () {
        playItem(items[0], container);
      }, 300);
    }

    // Pause when scrolled out of view
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && currentlyPlaying) {
              const stillVisible = entry.target.contains(currentlyPlaying);
              if (stillVisible) {
                pauseItem(currentlyPlaying);
                currentlyPlaying = null;
              }
            }
          });
        },
        { threshold: 0 }
      );
      obs.observe(container);
    }
  }

  function initAll() {
    document
      .querySelectorAll('.video-carousel-container')
      .forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor reloads section
  document.addEventListener('shopify:section:load', initAll);
})();
